// import React, {FC, ReactNode} from 'react';
// import Box from "@mui/material/Box";
// import {NavBar} from "./NavBar/NavBar";
// import {Footer} from "./Footer/Footer";

// interface MainLayoutProps {
//     children: ReactNode;
// }

// export const MainLayout: FC<MainLayoutProps> = ({children}) => {
//     return (
//         <Box sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
//             <NavBar/>
//             <Box sx={{
//                 flex: 1,
//                 maxWidth: '1700px',
//                 margin: "0 auto",
//                 width: "100%"
//             }}>
//                 {children}
//             </Box>
//             <Footer/>
//         </Box>
//     );
// };



import { FC, ReactNode, useState, useEffect } from 'react';
import Box from "@mui/material/Box";
import { Footer } from "./Footer/Footer";
import { motion } from "framer-motion";
import { NavBar } from './NavBar/NavBar';

interface MainLayoutProps {
    children: ReactNode;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

            {/* Animated Navbar with smooth margin & rounded corners on scroll */}
            {/* <motion.div
                animate={{
                    margin: scrolled ? "50px 20px 0px 50px" : "0px",
                    border: scrolled ? "5px solid grey" : "none",
                    borderRadius: scrolled ? "10px" : "0px",
                    width: scrolled ? "calc(100% - 100px)" : "100%", // Adjust width smoothly
                }}
                transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }} // Smooth cubic-bezier easing
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                }}
            >
                <NavBar />
            </motion.div> */}
            <motion.div
                animate={{
                    margin: scrolled
                        ? window.innerWidth > 600
                            ? "50px 20px 0px 50px"  // Desktop margins
                            : "10px 5px 0px 10px"   // Mobile-friendly margins
                        : "0px",
                    border: scrolled ? "5px solid grey" : "none",
                    borderRadius: scrolled ? "10px" : "0px",
                    width: scrolled
                        ? window.innerWidth > 600
                            ? "calc(100% - 100px)"  // Desktop width adjustment
                            : "calc(100% - 20px)"   // Mobile width adjustment
                        : "100%",
                }}
                transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                }}
            >
                <NavBar />
            </motion.div>


            {/* Page Content */}
            <Box sx={{
                flex: 1,
                maxWidth: '1700px',
                margin: "0 auto",
                width: "100%"
            }}>
                {children}
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
};
